// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__lJsj7","box":"styles_box__-8gJ+","title":"styles_title__m+qhs","icon":"styles_icon__LnRWK","icone":"styles_icone__YcA4J"};